import * as UUID from "uuidjs";
import { windowUuid } from "./Actions";

const fetchWithUuid: (
  input: RequestInfo,
  init?: RequestInit
) => Promise<Response> = (input, init) => {
  const uuidRequestHeader = { 'x-snoam-request-uuid': UUID.generate() };
  const uuidWindowHeader = { 'x-snoam-window-uuid': windowUuid() };
  const initWithUuid = Object.assign({}, init ? init : {}, {
    headers: Object.assign(
      {},
      init && init.headers ? init.headers : {},
      uuidRequestHeader,
      uuidWindowHeader
    )
  });
  return fetch(input, initWithUuid);
};

export default fetchWithUuid;
